import { render } from "./UserRegistration.vue?vue&type=template&id=63589923&scoped=true&ts=true"
import script from "./UserRegistration.vue?vue&type=script&lang=ts"
export * from "./UserRegistration.vue?vue&type=script&lang=ts"

import "./UserRegistration.vue?vue&type=style&index=0&id=63589923&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63589923"]])

export default __exports__